import { css } from 'lit';
export const stylesBase = css `
  :host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`;
//# sourceMappingURL=styles.js.map